// extracted by mini-css-extract-plugin
module.exports = {"quantityUnit":"Quantity_quantityUnit__1nDiF","quantityPadding":"Quantity_quantityPadding__2kO4D"};